import type { App } from 'vue';
import ManualDetailDemo from '@src/Insurance/Pages/Manual/ManualDetailDemo.vue';
import { registerEmbedComponent } from '@src/Manual/Pages/composables/useManualEmbeds';

/**
 * Modular setup — registers the Manual live-demo island component used by
 * the insurance-contracts-detail / insurance-surveys-detail embeds.
 */
export function setup(app: App): void {
    void app;

    registerEmbedComponent('InsuranceManualDetail', ManualDetailDemo);
}
